import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import { Dav } from "../../../../dav/shared/dav";
import { DavService } from "../../../../dav/shared/dav.service";

@Injectable({
  providedIn: 'root'
})
export class DavResolver  {
  constructor(private davService: DavService) { }

  resolve(
    route: ActivatedRouteSnapshot
  ): Observable<any> | Promise<any> | any {
    return this.davService.getProfileOfDav(route.params.dav);
  }
}
